export const CardIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
			<path
				d="M14.4761 14.6335C15.507 14.6335 16.3427 13.7978 16.3427 12.7668C16.3427 11.7359 15.507 10.9002 14.4761 10.9002V14.6335Z"
				fill="#6F99C6"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2288 3.78821H2.11768V15.5245C2.11768 16.9973 3.31158 18.1912 4.78434 18.1912H19.8955V6.45488C19.8955 4.98212 18.7015 3.78821 17.2288 3.78821ZM3.89545 7.34593V5.56599H17.2288C17.7197 5.56599 18.1177 5.96396 18.1177 6.45488V16.4134H4.78434C4.29342 16.4134 3.89545 16.0155 3.89545 15.5245V9.12371H16.3356V7.34593H3.89545Z"
				fill="black"
			/>
		</svg>
	)
}
